// extracted by mini-css-extract-plugin
export default {"home1":"home_home1__q+Z11","header":"home_header__NETg5","home":"home_home__ElSJg","info":"home_info__6jdME","feature1":"home_feature1__9PF--"};